import { STATUS_CODE } from '../data/system_settings'
import { baseService } from './baseService'
import Response from '../data/entity/response_entity'
class AccountGroupUsers extends baseService {
  async getAll() {
    try {
      const res = await this.get('groups/all')
      if (res.status === STATUS_CODE.SUCCESS) {
        return Response({
          success: true,
          message: { content: res.data.data },
        })
      } else {
        return Response({
          success: false,
          message: { content: 'Có lỗi khi nhóm thành viên' },
        })
      }
    } catch (error) {
      handleError(error)
    }
  }
  async addListUserToGroup(data) {
    try {
      const res = await this.post('groups/add', data)
      if (res.status === STATUS_CODE.CREATED) {
        return Response({
          success: true,
          message: { content: res.data.data },
        })
      } else {
        return Response({
          success: false,
          message: { content: 'Có lỗi khi thêm nhóm thành viên' },
        })
      }
    } catch (error) {
      handleError(error)
    }
  }
  async removeListUserFromGroup(data) {
    try {
      const res = await this.post('groups/remove', data)
      if (res.status === STATUS_CODE.SUCCESS) {
        return Response({
          success: true,
          message: { content: res.data.data },
        })
      } else {
        return Response({
          success: false,
          message: { content: 'Có lỗi khi xóa nhóm thành viên' },
        })
      }
    } catch (error) {
      handleError(error)
    }
  }
}
const handleError = (error) => {
  let message = error.message || 'Lỗi không xác định'
  if (error.response) {
    const { status, data } = error.response
    message = data.error || 'Lỗi không xác định'
    if (status === STATUS_CODE.BAD_REQUEST) {
      message = 'Vui lòng kiểm tra lại dữ liệu'
    }
  }
  return Response({ success: false, message: { content: message } })
}

export const accountGroupUsers = new AccountGroupUsers()
